import { render, staticRenderFns } from "./SubAccountOffers.vue?vue&type=template&id=56a43cc6&scoped=true"
import script from "./SubAccountOffers.vue?vue&type=script&lang=js"
export * from "./SubAccountOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a43cc6",
  null
  
)

export default component.exports